<template>
  <section>
    <TableListing :items="items" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <template v-slot:cell(month)="data">
        <span>{{ getMonthName(data.item.month) }} {{ data.item.year }}</span>
      </template>
      <template v-slot:cell(orderEndingIn)="data">
        <span>{{ data.item.orderEndingIn }}</span>
      </template>
      <template v-slot:cell(count)="data">
        <span>{{ data.item.count }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'StorefrontReshipReportByMonth-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects'
    })
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: 'year',
        sortDesc: true,
        perPage: 25,
        page: 1
      },
      tableOptions: {
        totalRows: 10,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'clientName', label: 'Client', sortable: true },
        { key: 'month', label: 'Month', sortable: true },
        { key: 'orderEndingIn', label: 'Order Suffix', sortable: true },
        { key: 'count', label: 'Count', sortable: true }
      ]
    }
  },
  methods: {
    getMonthName(month) {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                      'July', 'August', 'September', 'October', 'November', 'December'];
      return months[parseInt(month) - 1] || month;
    }
  }
}
</script>

<style>

</style>